import es from "./es.json"

const locales = {
    es,
}

export {locales as default}


// WEBPACK FOOTER //
// ./assets/locales/index.js